import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Centered spinner. By default fills its container's height (used inside a
 *  page/panel). With `fullscreen`, it covers the whole viewport — used by the
 *  top-level AuthGate so a hard refresh shows a clean splash while `me` resolves,
 *  instead of briefly flashing a page (or the home dashboard) before auth is known. */
export function AppLoader({ label, fullscreen }: { label?: string; fullscreen?: boolean }) {
  const { t } = useTranslation();
  return (
    <div
      className={
        fullscreen
          ? 'fixed inset-0 z-50 grid place-items-center bg-background text-muted-foreground'
          : 'grid h-full min-h-40 w-full place-items-center bg-background py-20 text-muted-foreground'
      }
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-xs">{label ?? t('common.loading')}</span>
      </div>
    </div>
  );
}
